import { Card, CardContent } from "../../../../ui/card";
import { Button } from "../../../../ui/button";
import { AlertCircle, Info } from "lucide-react";

export function ErrorState({ error, navigate }) {
  return (
    <div className="container mx-auto p-6">
      <Card className="border-red-200">
        <CardContent className="pt-6">
          <div className="flex items-center gap-3 text-red-600">
            <AlertCircle className="w-6 h-6" />
            <div>
              <h2 className="text-xl font-semibold">Error Loading Job Details</h2>
              <p className="text-red-600 mt-2">{error}</p>
              <p className="text-sm text-gray-600 mt-1">
                Please check if the job ID is correct and try again.
              </p>
            </div>
          </div>
          <Button 
            onClick={() => navigate(-1)} 
            variant="outline" 
            className="mt-4"
          >
            Go Back
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}